import { FormQuestionDto } from "@green0meter/api-client";
import { isEmpty } from "lodash";

import {
  CustomFormSectionDto,
  SearchFilter,
} from "@components/common/MultistepForm";

export const getQueryFilteredSections = (
  sections: CustomFormSectionDto[],
  searchQuery: string,
  searchFilter: SearchFilter,
): CustomFormSectionDto[] => {
  return (
    sections?.map((section) => {
      const filteredQuestions = section.formQuestions?.filter((question) =>
        filterLogic(question, searchQuery, searchFilter),
      );
      const isMatchingQuery = section.name
        .toLowerCase()
        .includes(searchQuery.toLowerCase());

      return {
        ...section,
        isMatchingQuery:
          isMatchingQuery || (filteredQuestions && !isEmpty(filteredQuestions)),
        formQuestions: filteredQuestions,
      };
    }) || []
  );
};

const filterLogic = (
  question: FormQuestionDto,
  searchQuery: string,
  searchFilter: SearchFilter,
): boolean => {
  const matches: Record<SearchFilter, () => boolean> = {
    everything: () =>
      question.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      !!question.description?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      question.code.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (!!question.answerOptions &&
        question.answerOptions.some((answerOption) =>
          answerOption.name.toLowerCase().includes(searchQuery.toLowerCase()),
        )),
    answers: () =>
      !!question.answerOptions &&
      question.answerOptions.some((answerOption) =>
        answerOption.name.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    // TODO: TBD when we have files and notes
    notes: () =>
      question.description?.toLowerCase().includes(searchQuery.toLowerCase()) ??
      false,
    fileNames: () => question.code.toLowerCase().includes(searchQuery.toLowerCase()),
  };

  return matches[searchFilter]();
};
